import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import {
  loadRuntimeTranslations,
  i18nOptions,
} from './helpers/translationsHelper.ts';

const { language } = CSS_CONFIG;
const resources = {
  [language]: {
    [__BUILD_TRANSLATIONS__.ns]: __BUILD_TRANSLATIONS__.lng,
  },
};
// eslint-disable-next-line import/no-named-as-default-member
i18n.use(initReactI18next).init({
  ...i18nOptions,
  resources,
  lng: language,
});
loadRuntimeTranslations(i18n);

export default i18n;
